import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, LANGS } from "./translations";

const LanguageContext = createContext(null);

export const WHATSAPP_NUMBER = "34645459043";

function resolve(obj, path) {
  return path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("velmonte_lang") || "en");

  const meta = useMemo(() => LANGS.find((l) => l.code === lang) || LANGS[0], [lang]);

  useEffect(() => {
    localStorage.setItem("velmonte_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = meta.dir;
  }, [lang, meta.dir]);

  const t = useMemo(() => {
    return (path) => {
      const val = resolve(translations[lang], path);
      if (val !== undefined) return val;
      return resolve(translations.en, path) ?? path;
    };
  }, [lang]);

  const value = { lang, setLang, t, dir: meta.dir, langs: LANGS };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
  return ctx;
};
